import AppDialog from '../dialog/AppDialog';

import EventInfo from './EventInfo';
import EventInfoTab from './EventInfoTab';
import EventStatsTab from './EventStatsTab';
import EventMarketsTab from './EventMarketsTab';
import { eventMethods, eventGetters } from './eventCore';
import utils from 'Helpers/utils';
import AppEventBetsSidePanel from 'Pages/core/event/EventBetsSidePanel.vue';
import AppEventOrdersSidePanel from 'Pages/core/event/EventOrdersSidePanel.vue';
import AppEventPositionSidePanel from 'Pages/core/event/EventPositionSidePanel.vue';
import AppEventStatsSidePanel from 'Pages/core/event/EventStatsSidePanel.vue';
import Constants from 'Helpers/constants';

export default {
    name: 'app-event',
    components: {
        AppEventStatsSidePanel,
        AppEventBetsSidePanel,
        AppEventOrdersSidePanel,
        AppEventPositionSidePanel,
        EventInfo,
        EventMarketsTab,
        EventStatsTab,
        EventInfoTab,
        AppDialog,
    },

    requiredDictionaries: [],

    watch: {
        '$vuetify.breakpoint.width': {
            handler() {
                this.onResize();
            },
        },
        '$vuetify.breakpoint.height': {
            handler() {
                this.onResize();
            },
        },
        $route: {
            //we need to close event popup if user is logged out
            handler() {
                if (this.$route.name === 'login' && this.dialogOpen) {
                    this.cancel(false);
                }
            },
        },
    },

    props: {},

    data() {
        return {
            loading: false,
            tableHeight: null,
            dialogOpen: false,
            loadDataTimer: undefined,
        };
    },

    mounted() {
        console.log('Component %s mounted.', this.$options.name);

        this.onResize();
    },

    methods: {
        ...eventMethods(),
        open(feedLine) {
            this.event = {};
            this.event['ceId'] = feedLine.ceId;
            this.event['mId'] = feedLine.mId;
            this.event['iso3'] = feedLine.iso3;
            this.event['clId'] = feedLine.clId;
            this.event['clName'] = feedLine.clName;
            this.event['ctaId'] = feedLine.ctaId;
            this.event['ctaName'] = feedLine.ctaName;
            this.event['ctaLogo'] = feedLine.ctaLogo;
            this.event['cthId'] = feedLine.cthId;
            this.event['cthName'] = feedLine.cthName;
            this.event['cthLogo'] = feedLine.cthLogo;
            this.event['dg'] = feedLine.dg;
            this.event['leftUntilStart'] = feedLine.leftUntilStart ?? null;

            //need to init event stats to avoid data jumping after stats loading
            if (feedLine.mId === this.$const.DBALL_MARKET_LIVE) {
                this.eventStats['score'] = feedLine.sc;
                this.eventStats['scores'] = JSON.stringify(feedLine.asc);
                this.eventStats['is_scores_mismatch'] = feedLine.scDiff;
                this.eventStats['time'] = feedLine.time;
                this.eventStats['times'] = JSON.stringify(feedLine.atime);

                this.eventStats['red_home'] = feedLine.rHome;
                this.eventStats['red_away'] = feedLine.rAway;

                //event stats
                this.eventStats['yellow_home'] = feedLine.yHome;
                this.eventStats['yellow_away'] = feedLine.yAway;

                this.eventStats['fouls_home'] = feedLine.fHome;
                this.eventStats['fouls_away'] = feedLine.fAway;

                this.eventStats['fouls_home'] = feedLine.fHome;
                this.eventStats['fouls_away'] = feedLine.fAway;

                this.eventStats['possession_time_home'] = feedLine.pHome;
                this.eventStats['possession_time_away'] = feedLine.pAway;

                this.eventStats['attacks_home'] = feedLine.aHome;
                this.eventStats['attacks_away'] = feedLine.aAway;

                this.eventStats['dangerous_attacks_home'] = feedLine.daHome;
                this.eventStats['dangerous_attacks_away'] = feedLine.daAway;

                this.eventStats['shots_home'] = feedLine.sHome;
                this.eventStats['shots_away'] = feedLine.sAway;

                this.eventStats['shots_on_target_home'] = feedLine.stHome;
                this.eventStats['shots_on_target_away'] = feedLine.stAway;

                this.eventStats['hit_woodwork_home'] = feedLine.hwwHome;
                this.eventStats['hit_woodwork_away'] = feedLine.hwwAway;

                this.eventStats['corners_home'] = feedLine.cHome;
                this.eventStats['corners_away'] = feedLine.cAway;
            }

            this.dialogOpen = true;

            this.$nextTick(() => {
                let dialog = document.getElementsByClassName('event-dialog')[0];
                if (dialog) {
                    let zIndex = dialog.closest('.v-dialog.v-dialog--active').parentElement.style.zIndex;

                    dialog.closest('.v-dialog.v-dialog--active').parentElement.style.zIndex = parseInt(zIndex) + 1000;
                }

                //reset filters to default values
                this.$refs['eventMarketsTab'].toggleFilters = 0;
                this.$refs['eventMarketsTab'].periodId = null;
                this.$refs['eventMarketsTab'].isCornersMarketsOnly = false
                this.$refs['eventInfo'].prevScore = null;
            });

            utils.updateUserData(true);

            this.onResize();
        },

        cancel(withUpdateUserData = true) {
            this.dialogOpen = false;

            this.event = {};
            this.eventStats = {};

            this.$store.dispatch('EventModule/resetPrices');
            this.$store.dispatch('EventModule/resetBetFeedData');

            this.$refs['eventMarketsTab'].resetMarkets();

            this.$nextTick(() => {
                if (withUpdateUserData) {
                    utils.updateUserData(true);
                }
            });
        },

        onResize: function () {
            let paddingY = this.$vuetify.breakpoint.width <= 940 ? 25 : 65; // - padding top and bottom 2x16

            if (this.$vuetify.breakpoint.width > 2560) {
                this.tableHeight = this.$vuetify.breakpoint.height * 0.88 - paddingY;
            } else {
                this.tableHeight = this.$vuetify.breakpoint.height - paddingY;
            }
        },
        isEmptyStats: function () {
            return (
                !this.eventStats.yellow_home &&
                !this.eventStats.yellow_away &&
                !this.eventStats.fouls_home &&
                !this.eventStats.fouls_away &&
                !this.eventStats.possession_time_home &&
                !this.eventStats.possession_time_away &&
                !this.eventStats.attacks_home &&
                !this.eventStats.attacks_away &&
                !this.eventStats.dangerous_attacks_home &&
                !this.eventStats.dangerous_attacks_away &&
                !this.eventStats.shots_home &&
                !this.eventStats.shots_away &&
                !this.eventStats.shots_on_target_home &&
                !this.eventStats.shots_on_target_away &&
                !this.eventStats.hit_woodwork_home &&
                !this.eventStats.hit_woodwork_away &&
                !this.eventStats.corners_home &&
                !this.eventStats.corners_away
            );
        },

        calcPosition: function (bets) {
            let self = this;
            let totalBalance = 0;
            let betBalance;
            let betsCount = 0;

            bets.forEach((bet) => {
                if (
                    bet.status_id == this.$const.BET_STATUS_REJ ||
                    bet.status_id == this.$const.BET_STATUS_ABN ||
                    bet.status_id == this.$const.BET_STATUS_VOID
                ) {
                    //need to skip these bets

                    return;
                }

                let score;
                let betScore;

                if (self.event.mId !== self.$const.DBALL_MARKET_LIVE) {
                    score = '0-0';
                    betScore = '0-0';
                } else {
                    //Corners bets
                    if (bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_JOLLY || bet.type === Constants.BET_TYPE_CORNERS_HANDICAP_DOG ||
                        bet.type === Constants.BET_TYPE_CORNERS_GOAL_OVER || bet.type === Constants.BET_TYPE_CORNERS_GOAL_UNDER
                    ) {
                        score = utils.isValidNumber(self.eventStats.corners_home) ? (self.eventStats.corners_home + '-' + self.eventStats.corners_away) : null;
                        betScore = utils.isValidNumber(bet.corners_home) ? (bet.corners_home + '-' + bet.corners_away) : null;
                    } else { //Regular bets
                        if (bet.period_type_id == self.$const.GAME_PERIOD_FT || (self.eventStats.time && self.eventStats.time.includes('1H'))) {
                            score = self.eventStats.score;
                        } else if ('score_ir_ht' in bet) {
                            // if there is no balance in 1h bet and game is not in 1H then we received this bet after reload feed and need to use score_ir_ht score
                            score = bet.score_ir_ht;
                        }

                        betScore =  bet.score;
                    }

                    if (bet.is_live === 0) {
                        betScore = '0-0';
                    }
                }

                //possible situation when for LIVE game score not confirmed
                if (this.event.mId === self.$const.DBALL_MARKET_LIVE && (!score || !betScore)) {
                    return;
                }

                betsCount++;
                let balance = utils.wlCalculate(
                    bet.type,
                    bet.teamwhere,
                    score,
                    betScore,
                    bet.correct_score,
                    bet.handicap,
                    bet.odds,
                    bet.stake,
                    null
                );

                betBalance = balance['balance'];

                totalBalance += betBalance;
            });

            if (betsCount > 0) {
                return parseFloat(totalBalance).toFixed(2);
            }

            return null;
        },
    },
    computed: {
        ...eventGetters(),
        event: {
            get() {
                return this.$store.getters['EventModule/getEvent'];
            },
            set(value) {
                this.$store.commit('EventModule/setEvent', value);
            },
        },
        betsTotal: function () {
            return this.$store.getters['AppModule/getBetsByParams']({
                custom_event_id: this.event.ceId,
            }).filter((bet) => bet.status_id !== Constants.BET_STATUS_SET);
        },
        betsTotalSettled: function () {
            return this.$store.getters['AppModule/getBetsByParams']({
                custom_event_id: this.event.ceId,
            }).filter((bet) => bet.status_id === Constants.BET_STATUS_SET);
        },
        betsFTRegular: function () {
            // if (this.event.mId === this.$const.DBALL_MARKET_LIVE && this.eventStats.time && this.eventStats.time.includes('FT')) {
            //     return [];
            // }
            let bets = this.$store.getters['AppModule/getBetsByParams']({
                period_type_id: this.$const.EVENT_PERIOD_FT,
                custom_event_id: this.event.ceId,
            });

            bets = bets.filter((bet) => bet.type !== 'CO' && bet.type !== 'CU' && bet.type !== 'CJ' && bet.type !== 'CD')

            return bets;
        },
        bets1HRegular: function () {
            //if first half period is finished all 1h bets should be already settled
            //so no need to show position for 1h bets in this case
            // if (this.event.mId === this.$const.DBALL_MARKET_LIVE && this.eventStats.time && !this.eventStats.time.includes('1H')) {
            //     return [];
            // }
            let bets = this.$store.getters['AppModule/getBetsByParams']({
                period_type_id: this.$const.EVENT_PERIOD_1H,
                custom_event_id: this.event.ceId,
            });

            bets = bets.filter((bet) => bet.type !== 'CO' && bet.type !== 'CU' && bet.type !== 'CJ' && bet.type !== 'CD')

            return bets;
        },
        betsFTCorners: function () {
            // if (this.event.mId === this.$const.DBALL_MARKET_LIVE && this.eventStats.time && this.eventStats.time.includes('FT')) {
            //     return [];
            // }
            let bets = this.$store.getters['AppModule/getBetsByParams']({
                period_type_id: this.$const.EVENT_PERIOD_FT,
                custom_event_id: this.event.ceId,
            });

            bets = bets.filter((bet) => bet.type === 'CO' || bet.type === 'CU' || bet.type === 'CJ' || bet.type === 'CD')

            return bets;
        },
        bets1HCorners: function () {
            //if first half period is finished all 1h bets should be already settled
            //so no need to show position for 1h bets in this case
            // if (this.event.mId === this.$const.DBALL_MARKET_LIVE && this.eventStats.time && !this.eventStats.time.includes('1H')) {
            //     return [];
            // }
            let bets = this.$store.getters['AppModule/getBetsByParams']({
                period_type_id: this.$const.EVENT_PERIOD_1H,
                custom_event_id: this.event.ceId,
            });

            bets = bets.filter((bet) => bet.type === 'CO' || bet.type === 'CU' || bet.type === 'CJ' || bet.type === 'CD')

            return bets;
        },
        positionFTRegular: function () {
            if (!this.betsFTRegular.length) {
                return null;
            }
            return this.calcPosition(this.betsFTRegular);
        },
        position1HRegular: function () {
            if (!this.bets1HRegular.length) {
                return null;
            }
            return this.calcPosition(this.bets1HRegular);
        },
        positionFTCorners: function () {
            if (!this.betsFTCorners.length) {
                return null;
            }
            return this.calcPosition(this.betsFTCorners);
        },
        position1HCorners: function () {
            if (!this.bets1HCorners.length) {
                return null;
            }
            return this.calcPosition(this.bets1HCorners);
        },
        eventStats: {
            get() {
                return this.$store.getters['EventModule/getStats'];
            },
            set(value) {
                this.$store.commit('EventModule/setStats', value);
            },
        },
        betFeedData: {
            get() {
                return this.$store.getters['EventModule/getBetFeedData'];
            },
            set(value) {
                this.$store.commit('EventModule/setBetFeedData', value);
            },
        },
        orders: function () {
            return this.$store.getters['AppModule/getOrdersByParams']({
                custom_event_id: this.event.ceId,
            });
        },
        positionHeight() {
            let height = 0;

            if ((this.positionFTRegular || this.position1HRegular) && (this.positionFTCorners || this.position1HCorners) ) {
                height = 134 + 16;
            } else if (this.positionFTRegular || this.position1HRegular || this.positionFTCorners || this.position1HCorners) {
                height = 86 + 16;
            }

            return height;
        },
        tableHeightOrders() {
            let height = this.tableHeight;

            height = height - this.positionHeight;

            if (this.betsTotal.length || this.betsTotalSettled.length) {
                const splitCount = this.betsTotal.length && this.betsTotalSettled.length ? 3 : 2;
                const gapSize = this.betsTotal.length && this.betsTotalSettled.length ? 32 : 16;
                const headersSize = this.betsTotal.length && this.betsTotalSettled.length ? 68 : 34;

                let maxHeight = (height - gapSize) / splitCount - 34;
                let heightCalculated = this.orders.length * 66 + 4; //4 - extra margin bottom

                return heightCalculated > maxHeight ? maxHeight : heightCalculated;
            }

            return height - 34;
        },
        tableHeightBets() {
            let height = this.tableHeight;

            height = height - this.positionHeight;

            if (this.orders.length) {
                height = height - 16 - this.tableHeightOrders - 68;
            } else {
                height = height - 34;
            }

            if (this.betsTotal.length && this.betsTotalSettled.length) {
                let heightBetsTotal = this.betsTotal.length * 66 + 4;
                let heightBetsTotalSettled = this.betsTotalSettled.length * 66 + 4;

                if (heightBetsTotal + heightBetsTotalSettled + 16 < height) {
                    height = Math.max(heightBetsTotal, heightBetsTotalSettled);
                } else {
                    height = (height - 16 - 34) / 2;
                }
            }

            return height;
        },
    },
};
